import React, { useState, useEffect } from 'react';
import Logo from './Logo';
import NavMenu from './NavMenu';
import Hamburger from './Hamburger';
import Sidebar from './Sidebar';
import './Header.css';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  const toggleMenu = (): void => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = (): void => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleEscape = (e: KeyboardEvent): void => {
      if (e.key === 'Escape' && isMenuOpen) {
        closeMenu();
      }
    };

    document.addEventListener('keydown', handleEscape);
    document.body.style.overflow = isMenuOpen ? 'hidden' : '';

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  return (
    <>
      <Sidebar isOpen={isMenuOpen} onClose={closeMenu} />
      <header>
        <nav className="nav">
          <Logo />
          <Hamburger isOpen={isMenuOpen} onClick={toggleMenu} />
          <NavMenu />
        </nav>
      </header>
    </>
  );
};

export default Header;



